import React from 'react';
import {Redirect, Route} from 'react-router-dom';
import AuthenticationService from "../../services/AuthenticationService";
import {UserContext} from "../contexts/UserContext";
import redirectToAmbassador from "../config/redirectToAmbassador";

const getPreviousRoute = (props) => {
  if (props.location.hasOwnProperty('search') && props.location.search.includes("?source=")) {
    return props.location.pathname + props.location.search
  }
  return props.location.pathname
}

const redirectUser = (user, props) => {
  if (!AuthenticationService.isAuthenticated() || !user) {
    redirectToAmbassador()
    return null
  }
  if (!user.mfaEnabled || !user.mfaVerified) {
    return <Redirect to={{ pathname: '/mfa/verify', state: { from: getPreviousRoute(props) }}} />
  }
  return null
}

export const AuthenticatedRoute = ({ component: Component, ...rest  }) => (
  <UserContext.Consumer>
    {({user, loadingInitial}) => {
      if (!loadingInitial) {
        return (
          <Route {...rest} render={(props) => (
            AuthenticationService.isAuthenticated() && user && user.mfaEnabled && user.mfaVerified
              ? <Component {...props} previousRoute={getPreviousRoute(props)}/>
              : redirectUser(user, props)
          )} />
        )
      }
    }}
  </UserContext.Consumer>
);
